module.exports = __webpack_public_path__ + "img/RX-RAD-DIGI-Sala-8.2b3ea885.png";